/**
 * If someone clicks the image on the exhibitions query, the exhibition webpage link gets clicked
 */

if (document.querySelector( '.wp-block-mag-extension-upcoming-events') ) {
    document.querySelectorAll( '.wp-block-mag-extension-upcoming-events' ).forEach( query => {
        query.addEventListener( 'click', clickCardLink )
        query.classList.add('click-links')
    } )

    function clickCardLink( e ) {
        if (e.target.nodeName == 'IMG') {
            // find the parent node and then find the link within that node and click that link
            e.target.parentNode?.parentNode?.querySelector('a')?.click()
        }
    }
}